import { Api } from "@/services/api.js";

class Volunteer extends Api
{
  merchantId = process.env.VUE_APP_MERCHANT_ID;

  constructor() {
    super();
  }

  /**
   * @returns {Promise<RewardsList>}
   */
  async rewards(campaignId = '', memberUuId = '') {
    const config = {
      method: 'GET',
      url: `${this.apiHost}/campaigns/v2/merchants/${this.merchantId}/campaigns/${campaignId}/members/${memberUuId}/rewards`,
      headers: {
        'Content-Type': 'application/json'
      }
    };

    return this.$http(config);
  }

  async serviceTime(memberUuid = '', startDate = '', endDate = '') {
    const config = {
      method: 'GET',
      url: `${this.externalApiHost}/yunlin-welfare/merchant/${this.merchantId}/member/${memberUuid}/volunteer/service-time?startTime=${startDate}&endTime=${endDate}`,
      headers: {
        'Content-Type': 'application/json'
      }
    };

    return this.$http(config);
  }
}

export const volunteerApi = new Volunteer();
